import React, {Fragment} from "react";
import {Button, Dropdown, Menu, notification, Popconfirm, Row, Space} from "antd";
import PermissionHidden from "../../../../components/permissions/PermissionHidden";
import {
    CommentOutlined,
    CreditCardOutlined,
    DeleteOutlined,
    EditOutlined,
    EnvironmentOutlined,
    FileOutlined,
    HomeOutlined,
    HourglassOutlined,
    InfoCircleOutlined,
    LinkOutlined,
    MailOutlined,
    MergeCellsOutlined,
    NodeIndexOutlined,
    PhoneOutlined,
    PlusOutlined,
    ReloadOutlined,
    RollbackOutlined,
    SkinOutlined,
    TagOutlined
} from "@ant-design/icons";
import RestrictedHidden from "../../../../components/permissions/RestrictedHidden";
import {checkForfait, checkPermissions} from "../../../../components/permissions/functions";
import IntlMessage from "../../../../components/util-components/IntlMessage";
import ApiService from "../../../../services/ApiService";


export class FicheHeader extends React.Component {

    async onDeleteContact() {
        const {selected, fiche} = this.props
        if (!checkPermissions(["contact.delete"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/delete", {ids: [selected.id]})
        await fiche.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    async onRestoreContact() {
        const {selected, fiche} = this.props
        if (!checkPermissions(["contact.delete"]) || !checkForfait(["CRM", "COM", "FULL"])) {
            notification.error({
                message: <IntlMessage id="access.error"/>
            })
            return false
        }

        await ApiService.post("/contact/undelete/" + selected.id)
        await fiche.props.parent.getData(true)
        await fiche.getData()

        notification.success({
            message: <IntlMessage id="success.delete"/>
        })
    }

    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        var MENU = []
        if (selected) {
            MENU = [
                {
                    label: "Paiements",
                    key: "sub1",
                    type: "group",
                    children: [
                        {
                            label: (
                                <a href={"#"} onClick={() => {
                                    fiche.modalCerfa.show(selected)
                                }}>Enregistrer un paiement</a>
                            ),
                            key: '2',
                            icon: <CreditCardOutlined/>,
                        },
                        {
                            label: (
                                <a href={"#"} onClick={() => {
                                    fiche.modalAbonnement.show(selected)
                                }}>Enregistrer un abonnement</a>
                            ),
                            key: '36',
                            icon: <ReloadOutlined/>
                        },
                        {
                            label: (
                                <a href={"#"} onClick={() => {
                                    fiche.modalPromesse.show(selected.id, "CONTACT")
                                }}>Créer une promesse de don</a>
                            ),
                            key: '6',
                            icon: <HourglassOutlined/>
                        },

                    ]
                }

            ]

            if (selected && !selected.deleted && checkForfait(["CRM", "COM", "FULL"])) {
                MENU.splice(0, 0,
                    {
                        label: (
                            <a href={"#"} onClick={() => {
                                fiche.modalAddTag.show([selected.id], selected.categories)
                            }}>Ajouter des catégories</a>
                        ),
                        key: '0',
                        icon: <TagOutlined/>
                    },
                    {
                        label: (
                            <a href={"#"} onClick={() => {
                                fiche.modalMergeContact.show(selected)
                            }}>Fusionner le Contact</a>
                        ),
                        key: '30',
                        icon: <MergeCellsOutlined/>
                    },
                    {
                        label: "Familles",
                        key: "sub2",
                        type: "group",
                        children: [
                            {
                                label: (
                                    <a href={"#"} onClick={() => {
                                        fiche.modalAddFamille.show(selected.id, selected.familles)
                                    }}>Ajouter à la famille</a>
                                ),
                                key: '1',
                                icon: <HomeOutlined/>
                            },
                            {
                                label: (
                                    <a type={"text"} onClick={() => fiche.modalAddChild.show(selected.id)}>Ajouter un
                                        enfant</a>
                                ),
                                key: '16',
                                icon: <SkinOutlined/>,
                                disabled: selected.parents.length > 0
                            },
                            {
                                label: (
                                    <a type={"text"}
                                       onClick={() => fiche.modalAddFamilyLink.show(selected.id, selected.nom + " " + selected.prenom)}>Ajouter
                                        un lien familial</a>
                                ),
                                key: '17',
                                icon: <NodeIndexOutlined/>,
                            },
                        ]
                    },
                    {
                        label: "Complements",
                        key: "sub3",
                        type: "group",
                        children: [
                            {
                                label: (
                                    <a href={"#"}
                                       onClick={() => fiche.modalAddTel.show(selected.id, {}, selected.adresses)}>Ajouter
                                        un Numéro
                                        de Téléphone</a>
                                ),
                                key: '20',
                                icon: <PhoneOutlined/>
                            },
                            {
                                label: (
                                    <a href={"#"}
                                       onClick={() => fiche.modalAddEmail.show(selected.id, {}, selected.adresses)}>Ajouter
                                        une
                                        Adresse Email</a>
                                ),
                                key: '21',
                                icon: <MailOutlined/>
                            },
                            {
                                label: (
                                    <a href={"#"} onClick={() => fiche.modalAddField.show(selected.id)}>Ajouter une
                                        information</a>
                                ),
                                key: '10',
                                icon: <InfoCircleOutlined/>
                            },
                            {
                                label: (
                                    <a href={"#"} onClick={() => fiche.modalAddCom.show(selected.id)}>Ajouter une
                                        activité</a>
                                ),
                                key: '13',
                                icon: <CommentOutlined/>
                            },
                            {
                                label: (
                                    <a type={"text"} onClick={() => fiche.modalEditAdresse.show(selected.id)}>Ajouter
                                        une
                                        adresse</a>
                                ),
                                key: '14',
                                icon: <EnvironmentOutlined/>,
                                disabled: selected.parents.length > 0
                            },
                            {
                                label: (
                                    <a href={"#"} onClick={() => fiche.modalAddLink.show(selected.id)}>Ajouter un
                                        lien</a>
                                ),
                                key: '11',
                                icon: <LinkOutlined/>
                            },
                            {
                                label: (
                                    <a href={"#"} onClick={() => fiche.modalAddDoc.show(selected.id)}>Ajouter un
                                        document</a>
                                ),
                                key: '12',
                                icon: <FileOutlined/>
                            },
                        ]
                    }
                )

            }
        }

        if (selected && selected.sharedWith) { //REMOVE MERGE
            MENU = MENU.filter(i => i.key !== "30")
        }

        return (
            <Fragment>
                <Row style={{justifyContent: "flex-end", marginBottom: 10}}>
                    <Space>


                        <PermissionHidden permissions={["contact.edit"]}>
                            <Dropdown overlay={
                                <Menu
                                    mode="inline"
                                    items={MENU}
                                />
                            } trigger={['click']}>
                                <Button type="primary"
                                        icon={<PlusOutlined disabled={this.props.loading}/>}/>
                            </Dropdown>
                        </PermissionHidden>

                        {selected && !selected.deleted && (
                            <PermissionHidden permissions={["contact.edit"]}>
                                <Button
                                    onClick={() => fiche.modalEdit.show(selected, selected.parents.length > 0)}
                                    type="default" icon={<EditOutlined/>}/>
                            </PermissionHidden>
                        )}

                        <RestrictedHidden type="AUTH"
                                          condition={(i) => i.key === "Forfait" && ["CRM", "COM", "FULL"].includes(i.value)}>
                            <PermissionHidden permissions={["contact.delete"]}>

                                {selected && selected.deleted && (
                                    <Popconfirm
                                        title={"Êtes-vous sûrs de vouloir restaurer ce contact ? Attention, cela risque de créer des colisions !"}
                                        onConfirm={() => this.onRestoreContact()}
                                        okText="Oui"
                                        cancelText="Non"
                                        okType={"danger"}
                                    >
                                        <Button type={"dashed"}
                                                icon={<RollbackOutlined disabled={this.props.loading}/>}/>
                                    </Popconfirm>
                                )}

                                {selected && !selected.deleted && !selected.sharedWith && (
                                    <Popconfirm
                                        title={"Êtes-vous sûrs de vouloir supprimer ce contact ?"}
                                        onConfirm={() => this.onDeleteContact()}
                                        okText="Oui"
                                        cancelText="Non"
                                        okType={"danger"}
                                    >
                                        <Button type={"danger"}
                                                icon={<DeleteOutlined disabled={this.props.loading}/>}/>
                                    </Popconfirm>
                                )}
                            </PermissionHidden>
                        </RestrictedHidden>
                    </Space>
                </Row>
            </Fragment>
        )
    }
}
